const riot = require('riot');

riot.tag2('page-requests', '<div>requests</div>', '', '', function(opts) {
});